import { NextPage } from 'next';
import { ExpectedProps, PublicServerPropsFactory } from '@lib/factory/serverprops';
import { ContentManager } from '@data/content/ContentManager';
import { useTranslation } from '@hooks/useTranslation';
import s from './privacyPage.module.scss';
import cn from 'classnames';
import parse from 'html-react-parser';
import { PrivacyList } from '@helpers/helpers';
import { PageLayout } from '@components/PageLayout/PageLayout';
import { BannerComponentData } from '@components/Banner/Banner';
import { ScrollUpArrow } from '@components/UIKit/ScrollUpArrow/ScrollUpArrow';
export const getServerSideProps = PublicServerPropsFactory(async (props: ExpectedProps) => {
  const [banner] = await Promise.all([props.isBannerClosed ? Promise.resolve(null) : ContentManager.getBanner()]);
  return {
    ...props,
    banner
  };
});
interface PrivacyPageProps extends ExpectedProps {
  banner: BannerComponentData;
}
const PrivacyPage: NextPage<PrivacyPageProps> = ({}) => {
  const {
    translate: tr
  } = useTranslation();
  return <PageLayout data-sentry-element="PageLayout" data-sentry-component="PrivacyPage" data-sentry-source-file="index.tsx">
            <div className={cn('_container')}>
                <div className={s.privacyPage}>
                    <div className={cn(s.privacyPage__container, '_container')}>
                        <div className={s.privacyPage__test}>
                            <div className={s.privacyPage__body}>
                                <h1 className={cn(s.privacyPage__title, '_title')}>
                                    {tr({
                  id: 'privacy.page.title'
                })}
                                </h1>
                                {PrivacyList.map(({
                title,
                text
              }, index) => <div key={index} className={s.privacyPage__box}>
                                        {tr({
                  id: title,
                  defaultMessage: ' '
                }).trim().length > 0 && <div className={s.privacyPage__subtitle}>{tr({
                    id: title
                  })}</div>}

                                        <div className={s.privacyPage__text}>{parse(tr({
                    id: text
                  }))}</div>
                                    </div>)}
                            </div>
                            <ScrollUpArrow data-sentry-element="ScrollUpArrow" data-sentry-source-file="index.tsx" />
                        </div>
                    </div>
                </div>
            </div>
        </PageLayout>;
};
export default PrivacyPage;